import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as organizationOffering from '../../../../organization-offering'
import * as project from '../project'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: project.RESOURCE.payload.dimension.partialId,
      partialId: project.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Organization Offering associated with a given project',
    isOptional: true,
    name: 'Organization Offering',
    partialId: PartialId.Standard.create('org_offering'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        organizationOffering.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
